export default __webpack_public_path__ + "static/blog3-6303963b2f953c1f0e71909fc3616fc0.jpeg";